export const invoke = (fn, ...args) =>
  typeof fn === "function" ? fn(...args) : fn;

export const ifBuilder = condition => left => right => n => {
  return condition(n) ? invoke(left, n) : invoke(right, n) || "";
};
